









































import { DomesticPostageFee } from "@/graphql/client";
import { Component, Emit, Vue } from "vue-property-decorator";
import domesticPostageFeeService from "@/service/domesticPostageFeeService";
import ProgressLinear from "@/components/molecules/ProgressLinear.vue";

@Component({
  components: {
    ProgressLinear,
  },
})
export default class DimesticPostageFeeDeleteDialog extends Vue {
  //---------------------------
  // data
  //---------------------------
  isOpen = false;
  isProgressing = false;
  item: DomesticPostageFee =
    domesticPostageFeeService.defaultDomesticPostageFee;
  //---------------------------
  // mounted
  //---------------------------
  //---------------------------
  // computed
  //---------------------------
  //---------------------------
  // methods
  //---------------------------
  /**
   * ダイアログを表示します.
   */
  public open(item: DomesticPostageFee): void {
    this.item = item;

    this.isProgressing = false;
    this.isOpen = true;
  }

  /**
   * ダイアログを閉じます.
   */
  public close(): void {
    this.isProgressing = false;
    this.isOpen = false;
  }

  /**
   * 入力内容を保存します.
   */
  deleteItem(): void {
    this.isProgressing = true;
    //delete
    domesticPostageFeeService
      .deleteDomesticPostageFee(this.item)
      .then((result) => {
        this.isProgressing = false;
        this.notifySuccess(result as DomesticPostageFee);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  /**
   * 処理成功
   */
  @Emit("onSuccess")
  public notifySuccess(deleted: DomesticPostageFee): DomesticPostageFee {
    return deleted;
  }
}
